'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.initializeGlobalTargetEnhancement = initializeGlobalTargetEnhancement;

var _onPageLoadCompleted = require('@nimius/event-utility/src/on-page-load-completed');

var _targetEnhance = require('./target-enhance');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description Enables target enhancement globally.
 * @summary
 * This method should be used to initialize the target enhancement functionality globally.
 * It activates target enhancement for every element that has the `data-target-enhancement`
 * attribute.
 *
 * If you want more fine grained control, or if you only want to enable target enhancement on a
 * specific element, you can use {@link targetEnhance}
 *
 * @example <caption>Initializes target enhancement for every [data-target-enhancement] element</caption>
 * // <a href="#element" data-target-enhancement">show</a>
 * // <div id="element">content</div>
 *
 * import { initializeGlobalTargetEnhancement } from '@nimius/target-enhancement';
 * initializeGlobalTargetEnhancement();
 *
 * @param {targetEnhance~options} [options] - The options for the initialization.
 */
function initializeGlobalTargetEnhancement() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    options.attribute = 'data-target-enhancement';

    (0, _onPageLoadCompleted.onPageLoadComplete)(function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('[' + options.attribute + ']')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var element = _step.value;

                (0, _targetEnhance.targetEnhance)(element, options);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/target-enhancement/src/initialize-global-target-enhancement.js
// module id = 142
// module chunks = 4